import {reactive, computed, watch} from 'vue';

export default function GeoZone(data = {}) {
    // Reactive state for geo zone fields
    const state = reactive({
        id: data.id || '',
        name: data.name || '',
        description: data.description || '',
        zoneType: data.zoneType || 'SERVICE_AREA',
        priority: data.priority || 0,
        active: data.active !== undefined ? data.active : true,
        boundaryWkt: data.boundaryWkt || '',
        createdAt: data.createdAt || null,
        updatedAt: data.updatedAt || null
    });

    // Computed properties for validations
    const validations = {
        isNameValid: computed(() => !!state.name.trim()),
        isZoneTypeValid: computed(() => !!state.zoneType),
        isBoundaryWktValid: computed(() => !!state.boundaryWkt.trim())
    };

    // Individual field validation functions
    const validateName = () => {
        if (validations.isNameValid.value) {
            $('#name').removeClass('is-invalid');
            $('#name-error').addClass('d-none');
            return true;
        } else {
            $('#name').addClass('is-invalid');
            $('#name-error').removeClass('d-none');
            return false;
        }
    };

    const validateZoneType = () => {
        if (validations.isZoneTypeValid.value) {
            $('#zoneType').removeClass('is-invalid');
            $('#zoneType-error').addClass('d-none');
            return true;
        } else {
            $('#zoneType').addClass('is-invalid');
            $('#zoneType-error').removeClass('d-none');
            return false;
        }
    };

    const validateBoundaryWkt = () => {
        if (validations.isBoundaryWktValid.value) {
            $('#boundaryWkt').removeClass('is-invalid');
            $('#boundaryWkt-error').addClass('d-none');
            return true;
        } else {
            $('#boundaryWkt').addClass('is-invalid');
            $('#boundaryWkt-error').removeClass('d-none');
            return false;
        }
    };

    // Set up watchers for real-time validation
    watch(() => state.name, validateName);
    watch(() => state.zoneType, validateZoneType);
    watch(() => state.boundaryWkt, validateBoundaryWkt);

    // Validation logic for the entire form
    const isValid = () => {
        let isNameValid = validateName();
        let isZoneTypeValid = validateZoneType();
        let isBoundaryWktValid = validateBoundaryWkt();

        return isNameValid && isZoneTypeValid && isBoundaryWktValid;
    };

    // Initialize validation
    const initializeValidation = () => {
        // Only validate fields that have values
        if (state.name) validateName();
        if (state.zoneType) validateZoneType();
        if (state.boundaryWkt) validateBoundaryWkt();
    };

    // Call initialization after a short delay to ensure DOM is ready
    setTimeout(initializeValidation, 100);

    return {
        state,
        validations,
        isValid,
        initializeValidation
    };
}